import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-WMSM002',
  templateUrl: './WMSM002.component.html',
  styleUrls: ['./WMSM002.component.scss'],
})
export class WMSM002Component extends BaseComponent implements OnInit {
  formValues: any;
  validateForm: FormGroup;
  Buyerlimits: boolean = false;
  nzTotal: number = 0;
  listOfData: any[] = [];
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  isShowCondition: boolean = true;
  isUser: boolean;
  isVendor: boolean;
  isBuyer: boolean;
  ChangeX: string;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.matomotracker.trackPageView("交期互動")
    this.matomotracker.trackEvent("交期互動", "交期查詢", "Report", 1);
    this.validateForm = this.fb.group({
      BuyerID: [''],
      PONO: [''],
      PRNO: [''],
      PODFrom: [''],
      PODto: [''],
      RTorNot: "",
    });
    this.LayoutComponent.geturl()
  }
  getFormValue(value) {
    this.formValues = value;
  }
  getQuery(value) {
    this.isShowCondition = value;
  }

  onSearch() {
    this.getResultData();
  }

  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.wmsm002DeliveryDateQuery.url}`;
    const startDate = this.formValues.POApprovedate.length !== 0 ? this.formValues.POApprovedate[0] : '';
    let endDate = '';
    if (this.formValues.POApprovedate.length !== 0) {
      const endDateObj = new Date(this.formValues.POApprovedate[1]);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDate = endDateObj.toISOString().split('T')[0];
    }
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Buyer: this.formValues.Buyer,
        Pono: this.formValues.PONO,
        Prno: this.formValues.PRNO,
        vendorCode: this.formValues.Vendor,
        Site: this.formValues.Site,
        Category: this.formValues.Type,
        FPoDate: this.getTheDateString_(startDate) || '',
        TPoDate: this.getTheDateString_(endDate) || '',
        type: '', //後端會重取
        RTorNot: this.formValues.RTorNot,
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
        ) {
          this.listOfData = res.data.map((item) => {
            item.rtDate = DateUtil.formatYMD(item.rtDate);
            item.deliveryDate = DateUtil.formatYMD(item.deliveryDate);
            item.vDate = DateUtil.formatYMD(item.vDate);
            item.uDate = DateUtil.formatYMD(item.uDate);
            item.prDate = DateUtil.formatYMD(item.prDate);
            item.poDate = DateUtil.formatYMD(item.poDate);
            item.approvedate = DateUtil.formatYMD(item.approvedate);
            return item;
          });
          this.nzTotal = res.total;
          this.NzMessageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }
  // 切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  // 切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }



  // 下载
  exportTableToExecl() {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.wmsm002DownLoadDeliveryDateQueryExcel.url}`;
    const startDate = this.formValues.POApprovedate.length !== 0 ? this.formValues.POApprovedate[0] : '';
    let endDate = '';
    if (this.formValues.POApprovedate.length !== 0) {
      const endDateObj = new Date(this.formValues.POApprovedate[1]);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDate = endDateObj.toISOString().split('T')[0];
    }
    const params = {
      data: {
        Buyer: this.formValues.Buyer,
        Prno: this.formValues.PRNO,
        Pono: this.formValues.PONO,
        vendorCode: this.formValues.Vendor,
        Site: this.formValues.Site,
        FPoDate: this.getTheDateString_(startDate) || '',
        TPoDate: this.getTheDateString_(endDate) || '',
        type: '', //後端會重取
        Category: this.formValues.Type,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        RTorNot: this.formValues.RTorNot,
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `Delivery_Conf_Report_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  onQueryClick(): string {
    return 'deliveryQueryService';
  }

  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.pono.localeCompare(b.pono)
    ) : this.listOfData.sort(
      (a, b) => b.pono.localeCompare(a.pono)
    )
  }

  downloadFile(data, name) {
    this.WebApiService.downloadFileByToken(data).subscribe(
      (res) => {
        this.downloadFile8(res, name);
        this.translate.get('DownloadSuccessfully').subscribe((translatedText: string) => {
          this.NzMessageService.success(translatedText);
        })
        // this.messageService.success("下载成功");

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }
}
